export default __webpack_public_path__ + "static/media/buy.a67c3de6.svg";